import $ from 'jquery'
import SlimSelect from 'slim-select'
import autosize from 'autosize'

window.addEventListener('load', function() {

  // Update the product ID in wishlist modal selection.
  var wishlistButtons = document.querySelectorAll('button[data-open="whishlistModal"]');
  for (const wishlistButton of wishlistButtons ) {
    wishlistButton.addEventListener('click', function() {
      document.getElementById('whishlistModal').dataset.productId = this.dataset.productId;
    });
  }

  // Deal with products.
  add_product_from_wishlist();
  remove_product_from_wishlist();

  // Deal with wishlists.
  // Rename - Delete wishlist
  wishlist_event_listener();
  save_wishlist_note();
  create_wishlist();

  if ( js_translation.wishlistCookieWithJS ) {
    checkCookie();
  }

  // Focus input when revealing it (sorry this code is a little crappy)
  $('.js-wishlist-ask-creation-button').on('click', () => {
    window.setTimeout(() => {
      $('#wishlist-name').focus();
    }, 50)
  })
});


function checkCookie() {
  var current_cookie = getCookie('cinier_wishlists');
  var indexToDelete = [];

  for (var i = 0; i < js_translation.wishlistCookie.length; i++) {
    var toCheck = js_translation.wishlistCookie[i];
    current_cookie.forEach(function(item, index) {
      if (toCheck === item) {
        indexToDelete.push(index);
      }
    });
  }
  for (var j = 0; j < indexToDelete.length; j++) {
    current_cookie.splice(indexToDelete[j], 1);
  }

  if (0 != current_cookie.length) {
    setCookie('cinier_wishlists', current_cookie, 30);
  } else {
    setCookie('cinier_wishlists', current_cookie, -30);
  }
}

/**
 * Set a cookie to current user browser.
 *
 * @param {string} cname  Cookie name.
 * @param {mixed} cvalue Cookie value.
 * @param {date} exdays Cookie expiration date.
 */
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + JSON.stringify(cvalue) + ";" + expires + ";path=/";
}

/**
 * Get cookie current user browser.
 *
 * @param  {string} cname Name of the cookie to get.
 * @return {[mixed}       The cookie value or empty if nothing is set.
 */
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return JSON.parse(c.substring(name.length, c.length));
    }
  }
  return [];
}

function create_wishlist() {
  var wishlistCreationButtons = document.querySelectorAll('.js-wishlist-create-button');
  if (null !== wishlistCreationButtons) {
    for (const wishlistCreationButton of wishlistCreationButtons ) {
      wishlistCreationButton.addEventListener('click', function() {
        var creationWishlistArea = wishlistCreationButton.closest('.js-wishlist-creation-form');
        var creationLocation = creationWishlistArea.getAttribute('data-creation-location');
        var wishlistName = document.getElementsByName('wishlist-name');
        var wishListsContainer = document.querySelector('.js-wishlist-list');

        // Disable saveWishListNoteButton during ajax load
        document.body.classList.add('loading')
        wishlistCreationButton.disabled = true

        // Ajax Call
        var xhr = new XMLHttpRequest();
        var loadNewsAjaxUrl =
          'action=wishlist_create' +
          '&wp-nonce=' + wishlistCreationButton.getAttribute('data-nonce') +
          '&wishlist-title=' + wishlistName[0].value +
          '&creation-location=' + creationLocation;
        xhr.open('POST', ajaxurl, true);
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.onload = function() {
          if (xhr.status === 200) {
            var response = JSON.parse(xhr.response);
            // Reable wishlistCreationButton after ajax load
            document.body.classList.remove('loading');
            wishlistCreationButton.disabled = false;

            // Deal with response
            if (response.success) {
              wishlistName[0].value = '';
              creationWishlistArea.classList.add('hide');

              // Use JS to deal with cookies if PHP not available.
              if (js_translation.wishlistCookieWithJS && !response.user_is_logged_in) {
                var current_user_wihslists = getCookie('cinier_wishlists');
                if (current_user_wihslists != "") {
                  current_user_wihslists.push(response.wishlist_id);
                } else {
                  current_user_wihslists = [response.wishlist_id];
                }

                setCookie('cinier_wishlists', current_user_wihslists, 30);
              }
            }

            // Output the result of creation
            if ('listing' == creationLocation) {
              wishListsContainer.innerHTML = response.output + wishListsContainer.innerHTML;

              if (1 <= document.querySelector('.js-wishlist-list').children.length) {
                var noWishlistContainer = document.querySelector('.js-no-wishlist');
                noWishlistContainer.classList.add('hide');
              }

              wishlist_event_listener();
            } else if ('product' == creationLocation) {
              var wishlist_dialog = document.querySelector('.js-add-product-to-wishlist-dialog .reveal__content .reveal__body .wishlist__content');
              wishlist_dialog.innerHTML = response.output;
              wishlist_event_listener();
              add_product_from_wishlist();
              create_wishlist();
              slimSelect();
              document.querySelector('.js-add-product-to-wishlist').click();
            }
          }
        };
        xhr.send(loadNewsAjaxUrl);
      });
    }
  }
}

function delete_wishlist() {
  var deleteWishlistButtons = document.querySelectorAll('.js-wishlist-delete');
  // When clicking on a "Delete" button do treatment.
  deleteWishlistButtons.forEach((deleteWishlistButton, index) => {
    deleteWishlistButtons[index].addEventListener('click', function(event) {
      event.preventDefault();
      // Disable removeProductButton during ajax load
      deleteWishlistButton.classList.add('disabled');

      // Ajax Call
      var xhr = new XMLHttpRequest();
      var loadNewsAjaxUrl = ajaxurl +
        '?action=wishlist_delete' +
        '&wp-nonce=' + deleteWishlistButton.getAttribute('data-nonce') +
        '&wishlist-id=' + deleteWishlistButton.closest('li.js-wishlist-item').getAttribute('data-wishlist-id');
      xhr.open('GET', loadNewsAjaxUrl);
      xhr.onload = function() {
        if (xhr.status === 200) {
          var response = JSON.parse(xhr.response);

          // Use JS to deal with cookies if PHP not available.
          if (js_translation.wishlistCookieWithJS && !response.user_is_logged_in) {
            var current_user_wishlists = getCookie('cinier_wishlists');
            var wishlistID = current_user_wishlists.indexOf(response.wishlist_id);
            if (wishlistID > -1) {
              current_user_wishlists.splice(wishlistID, 1);
            }

            if (0 != current_user_wishlists.length) {
              setCookie('cinier_wishlists', current_user_wishlists, 30);
            } else {
              setCookie('cinier_wishlists', current_user_wishlists, -30);
            }
          }

          // Remove line corresponding to the wishlist.
          deleteWishlistButton.closest('li.js-wishlist-item').remove();
          if (0 == document.querySelector('.js-wishlist-list').children.length) {
            var noWishlistContainer = document.querySelector('.js-no-wishlist');
            noWishlistContainer.classList.remove('hide');
            document.body.classList.remove('has-wishlist')
          }
        }
      };
      xhr.send();

    });
  });
}

function save_wishlist_note() {
  var saveWishListNoteButton = document.querySelector('.js-wishlist-save-note');
  if (null != saveWishListNoteButton) {
    saveWishListNoteButton.addEventListener('click', function() {
      var wishlistNote = document.getElementsByName('wishlist-note');

      // Disable saveWishListNoteButton during ajax load
      // saveWishListNoteButton.classList.add('disabled');
      saveWishListNoteButton.disabled = true

      // Ajax Call
      var xhr = new XMLHttpRequest();
      var loadNewsAjaxUrl =
        'action=wishlist_save_note' +
        '&wp-nonce=' + saveWishListNoteButton.getAttribute('data-nonce') +
        '&wishlist-id=' + saveWishListNoteButton.getAttribute('data-wishlist-id') +
        '&wishlist-note=' + wishlistNote[0].value;
      xhr.open('POST', ajaxurl, true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.onload = function() {
        if (xhr.status === 200) {
          // Reable saveWishListNoteButton after ajax load
          // saveWishListNoteButton.classList.remove('disabled');
          saveWishListNoteButton.disabled = false
        }
      };
      xhr.send(loadNewsAjaxUrl);
    });
  }
}

function wishlist_rename() {
  var renameWishlistButtons = document.querySelectorAll('.js-js-wishlist-rename-save');
  renameWishlistButtons.forEach((renameWishlistButton, index) => {
    renameWishlistButtons[index].addEventListener('click', function() {
      var wishlistLine = renameWishlistButton.closest('li');
      var wishlistID = wishlistLine.getAttribute('data-wishlist-id');
      var titleContainer = wishlistLine.querySelector('.js-wishlist-title');

      // Disable renameWishlistButton during ajax load
      // renameWishlistButton.classList.add('disabled');
      renameWishlistButton.disabled = true

      // Ajax Call
      var xhr = new XMLHttpRequest();
      var loadNewsAjaxUrl =
        'action=wishlist_rename' +
        '&wp-nonce=' + renameWishlistButton.getAttribute('data-nonce') +
        '&wishlist-id=' + wishlistID +
        '&wishlist-title=' + titleContainer.innerHTML;
      xhr.open('POST', ajaxurl, true);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.onload = function() {
        if (xhr.status === 200) {
          wishlist_rename_state(renameWishlistButton);
          // Reable renameWishlistButton after ajax load
          // renameWishlistButton.classList.remove('disabled');
          renameWishlistButton.disabled = false
        }
      };
      xhr.send(loadNewsAjaxUrl);
    });
  });
}

function wishlist_rename_state(button) {
  var wishlistLine = button.closest('li.js-wishlist-item');

  // Change text container to an editable container.
  var titleContainer = wishlistLine.querySelector('.js-wishlist-title');
  if (titleContainer.hasAttribute('contenteditable')) {
    titleContainer.removeAttribute('contenteditable');
    titleContainer.blur();
    wishlistLine.classList.remove('is-editing')
  } else {
    titleContainer.setAttribute('contenteditable', true);
    titleContainer.focus();
    wishlistLine.classList.add('is-editing')
  }

  // Dislay save button and hide "view" buttons.
  var whislistActionContainer = wishlistLine.querySelector('.js-wishlist-actions');
  whislistActionContainer.querySelector('.js-wishlist-actions-edit').classList.toggle('hide');
  whislistActionContainer.querySelector('.js-wishlist-actions-view').classList.toggle('hide');
}

function wishlist_event_listener() {
  var askRenameWishlistButtons = document.querySelectorAll('.js-wishlist-rename');
  askRenameWishlistButtons.forEach((askRenameWishlistButton, index) => {
    askRenameWishlistButtons[index].addEventListener('click', function(event) {
      event.preventDefault();
      wishlist_rename_state(this);
    });
  });
  var cancelRenameWishlistButtons = document.querySelectorAll('.js-wishlist-rename-cancel');
  cancelRenameWishlistButtons.forEach((askRenameWishlistButton, index) => {
    cancelRenameWishlistButtons[index].addEventListener('click', function(event) {
      event.preventDefault();
      wishlist_rename_state(this);
      titleContainer.innerHTML = titleContainer.getAttribute('data-old-title');
    });
  });
  wishlist_rename();
  delete_wishlist();
}

function add_product_from_wishlist() {
  var addProductButton = document.querySelector('.js-add-product-to-wishlist');
  addProductButton.addEventListener('click', function() {
    var addProductArea = addProductButton.closest('.js-wishlist-container');
    var addProductToWishlistDialog = addProductButton.closest('.js-add-product-to-wishlist-dialog');
    var productId = addProductToWishlistDialog.getAttribute('data-product-id');
    var wishlistList = document.querySelector('#whishlistModal select.js-wishlist-select');
    var wishlistListSlimSelect = document.querySelector('#whishlistModal div.js-wishlist-select');

    var productFavButton = document.querySelector('.button--fav[data-product-id="' + productId + '"]');
    var produtCard = productFavButton.closest('.card');
    var produtSingle = productFavButton.closest('.product');

    const reveal = document.querySelector('.reveal');
    const callout = reveal.querySelector('.callout');

    // Disable addProductButton during ajax load
    addProductButton.disabled = true

    // Ajax Call
    var xhr = new XMLHttpRequest();
    var loadNewsAjaxUrl = ajaxurl +
      '?action=add_product_to_wishlist' +
      '&wp-nonce=' + addProductButton.getAttribute('data-nonce') +
      '&wishlist-id=' + wishlistList.value +
      '&product-id=' + productId;
    xhr.open('GET', loadNewsAjaxUrl);
    xhr.onload = function() {
      if (xhr.status === 200) {
        var response = JSON.parse(xhr.response);
        if (response.success) {
          wishlistListSlimSelect.querySelector('.ss-single-selected span sup').innerHTML = response.output;
          wishlistListSlimSelect.querySelector('.ss-content div.ss-list div.ss-option-selected sup').innerHTML = response.output;
          // Message in reveal
          callout.classList.remove('is-visible', 'has-error', 'has-success');
          callout.classList.add('is-visible', 'has-success');
          callout.querySelector('.js-response').innerHTML = response.message;

          var newWishlistSeparator = ',';
          if ( produtCard && !produtCard.classList.contains( 'has-wishlist' ) ) {
            produtCard.classList.add('has-wishlist')
            newWishlistSeparator = '';
          }
          else if ( produtSingle && !produtSingle.classList.contains( 'has-wishlist' )  ) {
            produtSingle.classList.add('has-wishlist')
            newWishlistSeparator = '';
          }

          productFavButton.dataset.productInWishlist = productFavButton.dataset.productInWishlist + newWishlistSeparator + wishlistList.value
        } else {
          // Message in reveal
          callout.classList.remove('is-visible', 'has-error', 'has-success');
          callout.classList.add('is-visible', 'has-error');
          callout.querySelector('.js-response').innerHTML = response.message;
        }
        // Reable addProductButton during ajax load
        addProductButton.disabled = false
      }
    };
    xhr.send();
  });
}

function remove_product_from_wishlist() {
  var removeProductButtons = document.querySelectorAll('.js-wishlist-delete-product');
  var currentProductNumber = document.querySelector('.js-wishlist-product-nb');

  // When clicking on a "Delete" button do treatment.
  removeProductButtons.forEach((removeProductButton, index) => {
    removeProductButtons[index].addEventListener('click', function() {
      // Disable removeProductButton during ajax load
      // removeProductButton.classList.add('disabled');
      removeProductButton.disabled = true

      // Ajax Call
      var xhr = new XMLHttpRequest();
      var loadNewsAjaxUrl = ajaxurl +
        '?action=remove_product_from_wishlist' +
        '&wp-nonce=' + removeProductButton.getAttribute('data-nonce') +
        '&wishlist-id=' + removeProductButton.getAttribute('data-wishlist-id') +
        '&product-to-remove=' + removeProductButton.getAttribute('data-wishlist-product-id');
      xhr.open('GET', loadNewsAjaxUrl);
      xhr.onload = function() {
        if (xhr.status === 200) {
          // Remove line corresponding to the product.
          removeProductButton.closest('div.whishlist-product').remove();

          // Change the number of product in wishlist.
          currentProductNumber.innerHTML = xhr.responseText;
        }
      };
      xhr.send();
    });
  });
}

/**
 * Material UI Forms
 */

const $form = $(".js-wishlist-creation");
if ($form.length) {

  /**
   * Material UI
   */
  $form.addClass("is-material-ui");

  // Input Text, On Focus
  $form.on("focus", "[type=text], textarea", function(ev) {
    $(this).parents(".form-control").addClass('is-focused has-label');
  });
  // Input Text : On blur
  $form.on("blur", "[type=text], textarea", function(ev) {
    const $parent = $(this).parents(".form-control");
    if ($(this).val() === '') {
      $parent.removeClass('has-label');
    }
    $parent.removeClass('is-focused');
  });
  // Input Text :  Si un champs est rempli on rajoute directement la class has-label
  $form.on("change", "[type=text], textarea", function(ev) {
    if ($(this).val() !== '') {
      $(this).parents(".form-control").addClass('has-label');
    }
  });

  // Input Checkbox
  $form.on("click", "[type=checkbox]", function() {
    if ($(this).is(':checked')) {
      $(this).parents("li").addClass('is-checked');
    } else {
      $(this).parents("li").removeClass('is-checked');
    }
  })

  /**
   * Textarea auto size
   * We remove textarea rows attribute only because we have Autosize to resize it.
   * We're doing it in JS because there's no other way to do it with Gravity :sweat:
   */
  const textareas = $form[0].querySelectorAll('textarea')
  for (const el of textareas) {
    el.removeAttribute('rows')
    autosize(el)
  }
}

/**
 * Reveal Reinit closing button after Ajax replacement
 */
$('.reveal').on('open.zf.reveal', function () {
  $(this).find('.close-button').on('click', () => {
    $(this).foundation('close')
  })
});
$('.reveal').on('closed.zf.reveal', function () {
  $(this).find('.callout').removeClass('is-visible has-error has-success');
});

/**
 * Slim Select
 */
function slimSelect() {
  const whishlistSelect = document.querySelector('.js-wishlist-select')
  let datas = []
  for (const option of whishlistSelect.options) {
    const object = {}
    var tpl = js_translation.wishlistSlimSelectTpl;
    var nbProductText = js_translation.singleProductNb;
    if (2 <= option.dataset.count) {
      nbProductText = js_translation.pluralProductNb;
    }
    object.innerHTML = tpl.replace('{{ wishlist_title }}', option.dataset.title).replace('{{ wishlist_product_nb }}', nbProductText.replace('%d', option.dataset.count));
    object.text = option.dataset.title
    object.value = option.value
    datas.push(object)
  }

  const whishlistSlimSelect = new SlimSelect({
    select: whishlistSelect,
    showSearch: false,
    valuesUseText: false,
    data: datas
  })
}
slimSelect();
